import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["id", "aria-labelledby"]
const _hoisted_2 = { class: "modal-dialog modal-md modal-xl" }
const _hoisted_3 = { class: "modal-content modal-content-border-radius" }
const _hoisted_4 = ["id"]
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "modal-dialog modal-dialog-margin modal-md modal-lg modal-xl modal-dialog--open" }
const _hoisted_7 = { class: "modal-content modal-content-border-radius" }
const _hoisted_8 = { class: "modal-header image-modal-header" }
const _hoisted_9 = { class: "vehicle-info-container-wrapper-header" }
const _hoisted_10 = { class: "ps-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!

  return (_ctx.isMainModal)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "modal fade",
        id: _ctx.idData,
        tabindex: "-1",
        "aria-labelledby": _ctx.idData + 'Label'
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass(["modal-header", { 'modal-header-border p-0': !_ctx.showTitle }])
            }, [
              (_ctx.showTitle)
                ? (_openBlock(), _createElementBlock("h5", {
                    key: 0,
                    class: "modal-title",
                    id: _ctx.idData + 'Label'
                  }, _toDisplayString(_ctx.modalTitle), 9, _hoisted_4))
                : _createCommentVNode("", true),
              _createVNode(_component_ButtonComponent, {
                type: "button",
                "data-bs-dismiss": "modal",
                "aria-label": "Close",
                class: "modal-close-button"
              }, {
                btnContent: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createElementVNode("span", null, [
                    _createElementVNode("img", { src: "/assets/images/xTimes-1.svg" })
                  ], -1)
                ])),
                _: 1
              })
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["modal-body", { 'modal-body-padding': !_ctx.showTitle }])
            }, [
              _renderSlot(_ctx.$slots, "body-content")
            ], 2)
          ])
        ])
      ], 8, _hoisted_1))
    : (!_ctx.isMainModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          id: _ctx.id,
          class: _normalizeClass(["modal modal-custom", _ctx.zIndexCustom])
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_ButtonComponent, {
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close({ id: _ctx.id, backdrop: _ctx.backdrop, bodyOverflow: _ctx.bodyOverflow }))),
                  "aria-label": "Close",
                  class: "modal-close-button"
                }, {
                  btnContent: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createElementVNode("span", null, [
                      _createElementVNode("img", {
                        src: "/assets/images/xTimes-1.svg",
                        alt: "times"
                      })
                    ], -1)
                  ])),
                  _: 1
                })
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_9, [
                _createElementVNode("a", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.close({ id: _ctx.id, backdrop: _ctx.backdrop, bodyOverflow: _ctx.bodyOverflow }))),
                  class: "d-flex"
                }, [
                  _cache[4] || (_cache[4] = _createElementVNode("img", {
                    src: "/assets/images/arrow-right-1.svg",
                    alt: "arrow-1"
                  }, null, -1)),
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('choose-vehicle.back_to_list')), 1)
                ])
              ], 512), [
                [_vShow, _ctx.showLink]
              ]),
              _renderSlot(_ctx.$slots, "body-content")
            ])
          ])
        ], 10, _hoisted_5))
      : _createCommentVNode("", true)
}